import { HistoryCreatedInfo } from "@/features/history/HistoryCreatedInfo";
import { getHistoryIcon } from "@/features/history/activityIcons";
import { type HistoryGroup } from "@/features/history/utils";
import { type History } from "@repo/api";
import { ListViewItem, type ListViewItemProps } from "@repo/skapa";
import { useSettings } from "@repo/ui";

export const HistoryListViewItem = ({
  control,
  onClick,
  history,
  title,
  description,
}: {
  control: ListViewItemProps["control"];
  history: History | HistoryGroup;
  title: string;
  description?: ListViewItemProps["description"];
  onClick?: () => void;
}) => {
  const { task_configuration } = useSettings();
  return (
    <ListViewItem
      inset
      control={control}
      onClick={onClick}
      leadingIcon={getHistoryIcon(
        history.entryType,
        history.details?.parent_task_type,
        history.details?.sub_task_type ?? history.details?.task_type,
        task_configuration?.task_types
      )}
      title={title}
      description={description}
      addOn={
        <HistoryCreatedInfo
          createdBy={history.createdBy}
          createdAt={history.createdAt}
        />
      }
    />
  );
};
